import { render, staticRenderFns } from "./AllocatedProjectItem.vue?vue&type=template&id=228eccfe&scoped=true&"
import script from "./AllocatedProjectItem.vue?vue&type=script&lang=js&"
export * from "./AllocatedProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedProjectItem.vue?vue&type=style&index=0&id=228eccfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228eccfe",
  null
  
)

export default component.exports